(ns dre.modals.events
  (:require
    [day8.re-frame.tracing :refer-macros [fn-traced]]
    [dre.modals.db :as modals]
    [dre.modals.ds-stats.events]
    [re-frame.core :as rf]))


(def db-path :modals)


;; -- Events

(rf/reg-event-fx
  ::set-modal
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [{db :db} [modal-id init-data]]
    {:pre [(contains? modals/index modal-id)]}
    (let [{:keys [init-db init-fx]} (get modals/index modal-id)]
      {:db (-> db
               (assoc :current modal-id)
               (update-in [:data modal-id] (partial merge init-db)))
       :fx [(when init-fx
              [:dispatch [init-fx init-data]])]})))


(rf/reg-event-db
  ::clear
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [db]
    (dissoc db :current)))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (db-path db)))


(rf/reg-sub
  ::current-modal-id
  :<- [::state]
  (fn [db _]
    (:current db)))


(rf/reg-sub
  ::current-modal-data
  :<- [::state]
  (fn [db _]
    (get-in db [:data (:current db)])))
